import { css } from "styled-components";
import { colors, fonts, grid } from "../../utils/styled";

export const sectionStyle = css`
	${grid}
	display: block;
	overflow: hidden;
	padding-top: 80px;
	padding-bottom: 80px;
	background-color: ${colors.platinum};
`;

export const titleStyle = css`
	h2 {
		font-family: ${fonts.AeonikPro};
		font-size: 60px;
		font-weight: normal;
		line-height: 60px;
		letter-spacing: -1px;
		color: ${colors.infiosGray};
	}
	.rel-content__section__subtitle {
		font-family: ${fonts.AeonikMono};
		font-size: 19px;
		line-height: 24px;
		padding-bottom: 20px;
	}
`
